<div [ngClass]="{'loading in': view.loading && !view.viewContents }">
	<div class="panel panel-default" [ngClass]="{ 'tile-view': tiles }">
		<div class="panel-heading" *ngIf="view && view.viewContents">
			<div class="h3 panel-title flex">
				<!-- <a class="draggable-control text-muted ui-sortable-handle"><em class="fas fa-arrows-alt" title="Move Panel"><span class="sr-only">Move Widget</span></em></a> -->
				<div class="pull-left">
					<a class="panel-title" href="javascript:">
						<ol class="breadcrumb">
							<ng-container *ngFor="let crumb of view.viewContents.breadcrumb">
								<li *ngIf="crumb.path.indexOf(view.startingPath) > -1">
									<span class="very-title" (click)="openView(crumb.path, view)">{{crumb.name}}</span>
								</li>
							</ng-container>
						</ol>
					</a>
				</div>
				<!--
                <div class="pull-right panel-controls">
                    <div class="view-controls">
                        <a href="javascript:" (click)="setTiles(false)" [ngClass]="{'active': !tiles }" class="icon-link active">
                            <em class="fas fa-list" title="List View">
                                <span class="sr-only">List View</span>
                            </em>
                        </a>
                        <a href="javascript:" (click)="setTiles(true)" [ngClass]="{'active': tiles }" class="icon-link">
                            <em class="fas fa-th-large" title="Grid View">
                                <span class="sr-only">Grid View</span>
                            </em>
                        </a>
                    </div>
                </div>
                -->
			</div>
		</div>
		<div class="panel-body" class="panel-body" *ngIf="view && view.viewContents">
			<div [ngClass]="{'loading in': view.loading}">
				<!-- Temporary security for editable grid. Only internal users can see the button to edit metadata. -->
				<div *ngIf="massMetadataUpdates && view.viewContents.items && view.viewContents.items.length > 0 && !this.authService.isExternalUser()" class="edit-grid-div">
					<button *ngIf="!agGridChangesMade" class="btn btn-sm" (click)="toggleEditMode()"><em class="fas fa-edit"></em></button>
					<button *ngIf="agGridChangesMade" class="btn btn-sm" (click)="saveChangedObjs()"><em class="fas fa-save"></em></button>
					<button *ngIf="agGridChangesMade" class="btn btn-sm" (click)="cancelChangedObjs()"><em class="fas fa-window-close"></em></button>
				</div>

				<div *ngIf="view.viewContents.views && view.viewContents.views.length > 0">
					<div [attr.id]="viewPanel">
						<table class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted">
							<thead>
								<tr>
									<th id="views">Views</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let subview of view.viewContents.views" view-folder-row [ngStyle]="{'backgroundImage': tiles ? ('View' | thumbnailBackgroundUrl) : 'none', 'background-size': 'Folder' !== 'Content' ? '40%' : '' }" [item]="subview" [inGrid]="inGrid" [completedEnabled]="completedEnabled" [vaultProperties]="vaultProperties" [objectTypes]="objectTypes" [objectLists]="objectLists" (openView)="openView($event, view)">
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div *ngIf="view.viewContents.traditionalFolders && view.viewContents.traditionalFolders.length > 0">
					<div [attr.id]="viewPanel">
						<table class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted">
							<thead>
								<tr>
									<th id="traditionalFolders">Traditional Folders</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let folder of view.viewContents.traditionalFolders" view-folder-row [ngStyle]="{'backgroundImage': tiles ? ('Folder' | thumbnailBackgroundUrl) : 'none', 'background-size': 'Folder' !== 'Content' ? '40%' : '' }" [item]="folder" [inGrid]="inGrid" [completedEnabled]="completedEnabled" [vaultProperties]="vaultProperties" [objectTypes]="objectTypes" [objectLists]="objectLists" (openView)="openView($event, view)">
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div *ngIf="view.viewContents.folders && view.viewContents.folders.length > 0">
					<div [attr.id]="viewPanel">
						<table class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted">
							<thead>
								<tr>
									<th id="virtualFolders">Virtual Folders</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let folder of view.viewContents.folders" view-folder-row [ngStyle]="{'backgroundImage': tiles ? ('Folder' | thumbnailBackgroundUrl) : 'none', 'background-size': 'Folder' !== 'Content' ? '40%' : '' }" [item]="folder" [inGrid]="inGrid" [completedEnabled]="completedEnabled" [vaultProperties]="vaultProperties" [objectTypes]="objectTypes" [objectLists]="objectLists" (openView)="openView($event, view)">
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div *ngIf="view.viewContents.items && view.viewContents.items.length > 0 && hasDocuments()">
					<div [attr.id]="viewPanel">
						<div class="scroll-holder">
							<div class="table-scroll horizontal-scroll custom-scroll top">
								<table *ngIf="!editMode" class="full-width table table-striped table-fixed has-locked-deleted has-locked-and-deleted">
									<thead>
										<tr *ngIf=!tiles>
											<th id="completed" *ngIf="completedEnabled"></th>
											<th class="checkbox-column"></th>
											<th *ngFor="let column of view.viewContents.columns" [id]="column.name ? column.name.replace(' ', '-') : ''"><span [ngStyle]="{'curser': 'pointer'}">{{ column.name }}</span>
											<th id="upload"></th>
											<!--<th id="shareLink"></th>-->
											<th id="download"></th>
											<th id="delete"></th>
											<th id="coauthor" *ngIf="coauthorEnabled"></th>
											<!--<th id="associate" *ngIf="associateSelected"></th>-->
										</tr>
									</thead>
									<tbody>
										<ng-container *ngFor="let item of view.viewContents.items">
											<tr *ngIf="item.type === 0">
												<td *ngIf="completedEnabled"></td>
												<td class="checkbox-column"><input class="form-control file-selector" type="checkbox" [id]="item.id" (change)="itemChecked(item, $event)"></td>
												<td *ngFor="let column of view.viewContents.columns">
													<!-- The following columns are built in and have negative IDs. When we retrieve the properties for objects in M-Files, the property definition IDs
															for Name, Type, Size, etc. do not match up with the column IDs, hence the manual setting of column values below. -->
													<ng-container [ngSwitch]="column.id">
														<!-- Name == -1, otherwise show property that corresponds with column ID -->
														<ng-container *ngSwitchCase="-1">
															<div class="sub-name">
																<!-- Display the related objects arrows if the user is an internal user or if the user is external and the item is a document collection -->
																<!--
																<div *ngIf="!disableRelatedView">
																	<span class="expand-icon" *ngIf="!external || item.type === 9">
																		<a href="javascript:" (click)="getRelated()" *ngIf="!loadingRelated && (!item.expanded && !relatedLoaded || (relatedLoaded && (files.length > 1 || related.length > 0) && !showRelated))">
																			<em class="fas fa-chevron-circle-right"></em>
																		</a>
																		<a href="javascript:" (click)="hideRelated()" *ngIf="!loadingRelated && (!item.expanded && (files.length > 1 || related.length > 0) && showRelated)">
																			<em class="fas fa-chevron-circle-down"></em>
																		</a>
																		<em class="fas fa-circle-notch fa-spin" *ngIf="loadingRelated"></em>
																	</span>
																</div>
																-->

																<div>
																	<em *ngIf="!icon" class="icon icon-file icon-other" [ngClass]="'icon-'+item.extension"></em>
																	<em *ngIf="icon" class="icon icon-file icon-other" [ngStyle]="{'background': 'url(' + icon + ') no-repeat', 'background-size': 'contain'}"></em>
																	<label class="icon-pad" [for]="item.id">{{item.name}}</label>
																</div>

															</div>
														</ng-container>

														<!-- Type == -2 -->
														<ng-container *ngSwitchCase="-2">{{ objectTypes[item.type] ? objectTypes[item.type].name : '' }}</ng-container>

														<!-- Size == -3 -->
														<ng-container *ngSwitchCase="-3">{{ getItemSize(item) | mfObjectSize }}</ng-container>

														<!-- Version == -8 -->
														<ng-container *ngSwitchCase="-8">{{ item.version }}</ng-container>

														<!-- Date Created == -13 -->
														<ng-container *ngSwitchCase="-13">{{ item.dateCreated | date: defaultDateFormat ?? 'M/d/yyyy h:mm a' }}</ng-container>

														<!-- Date Modified == -14 -->
														<ng-container *ngSwitchCase="-14">{{ item.dateModified | date: defaultDateFormat ?? 'M/d/yyyy h:mm a' }}</ng-container>

														<ng-container *ngSwitchDefault>
															<span>{{ getDisplayValueForColumn(column) }}</span>
														</ng-container>
													</ng-container>
												</td>
												<td></td>
												<td></td>
												<td></td>
												<td *ngIf="coauthorEnabled"></td>
											</tr>
										</ng-container>
									</tbody>
								</table>

								<ag-grid-angular *ngIf="editMode" id="ag-grid" class="ag-theme-alpine" [columnDefs]="agGridColumnDefs" [rowData]="agGridRowData" [frameworkComponents]="frameworkComponents" [context]="context" rowSelection="multiple" enableCellTextSelection="true" autoSizeColumns="true" (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)" (cellClicked)="onCellClicked($event)"></ag-grid-angular>
							</div>
						</div>
					</div>
				</div>
				<div *ngIf="showNoDocs()">
					There are no documents
				</div>
			</div>
		</div>
	</div>
</div>